/**
 * 다국어 필드(name/nameEn 등)에서 현재 언어에 맞는 값을 꺼낸다.
 * 해당 언어 값이 비어있으면 기본(ko) 값으로 fallback.
 */
export const localized = (
  ko: string | null | undefined,
  en: string | null | undefined,
  lang: string
): string => {
  if (lang.startsWith('en')) return en?.trim() || ko || '';
  return ko || '';
};
